export default __webpack_public_path__ + "static/Clement-photo-de-profil-b53ee7b52b91ae98f47b9bec68c79f0c.jpg";